export default __webpack_public_path__ + "static/media/fomo.690aecd4.svg";